import config from '../../../../configs/app';

type ChainId = '35441' | '35442' | '35443';

interface NetworkLinks {
  hq: string;
}

const NetworkLinksConfig: Record<ChainId, NetworkLinks> = {
  '35441': {
    hq: 'https://hq.qgov.io/',
  },
  '35442': {
    hq: 'https://hq.qgov-test.io/',
  },
  '35443': {
    hq: 'https://hq.qgov-test.io/',
  },
};

export default function getQNetworkLinks(): NetworkLinks | undefined {
  if (!config.chain.id) {
    return;
  }
  return NetworkLinksConfig[config.chain.id as ChainId];
}
